// extracted by mini-css-extract-plugin
export default {"dragIcon":"topping-constructor-element_dragIcon__6Xe62","topping":"topping-constructor-element_topping__YwC0M"};